// import Report from './Report';

export default {
 // component: Report,
  component: load(() => import(/* webpackChunkName: "Evaluation360-Report" */ './Report')),
  permissions: ["360EvaluationMenu/EvaluationReportMenu"],
  name: app.translate('routes.home.evaluation-360.Report'),
  icon: 'file-chart',
  drawer: true,
};
